var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14V11C4 6.58 7.58 3 12 3C16.42 3 20 6.58 20 11V14",
    stroke: "#ffffff",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12.5,
    width: 4,
    height: 6,
    rx: 1.5,
    stroke: "#ffffff",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12.5,
    width: 4,
    height: 6,
    rx: 1.5,
    stroke: "#ffffff",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5V19C19 20.1 18.1 21 17 21H13.5",
    stroke: "#ffffff",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTickets);
export default __webpack_public_path__ + "static/media/support-tickets.7d145a23614bab8113cbcac10649b206.svg";
export { ForwardRef as ReactComponent };